/* Laat de PDP-hoofdprijs live meebewegen met Easify-opties (bv. "Gemonteerd
 * verzenden? Ja (24.95 EUR)"). Easify schrijft de gekozen waarde naar hidden
 * inputs `properties[...]` binnen zijn .easify-container; wij sommeren de
 * "(x EUR)"-bedragen daaruit en tellen ze op bij de servergerenderde
 * variantprijs (data-zknl-base-cents). Na een variantwissel rendert Dawn de
 * prijs-HTML opnieuw server-side, dus het basisbedrag klopt dan vanzelf weer
 * en passen we de add-on alleen opnieuw toe. */
(function () {
  function parseEuroCents(text) {
    var m = /\(\s*(\d+(?:[.,]\d{1,2})?)\s*EUR\s*\)/.exec(text || '');
    if (!m) return 0;
    return Math.round(parseFloat(m[1].replace(',', '.')) * 100) || 0;
  }

  function addonCents() {
    var total = 0;
    document
      .querySelectorAll('.easify input[type="hidden"][name^="properties["]')
      .forEach(function (input) {
        if (/^properties\[_/.test(input.name)) return; // interne Easify-velden
        total += parseEuroCents(input.value);
      });
    return total;
  }

  function formatCents(cents) {
    var whole = Math.floor(cents / 100);
    var rest = ('0' + (cents % 100)).slice(-2);
    return '€' + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + rest;
  }

  function apply() {
    var el = document.querySelector('[data-zknl-base-cents]');
    if (!el) return;
    var base = parseInt(el.getAttribute('data-zknl-base-cents'), 10);
    if (isNaN(base)) return;
    el.textContent = formatCents(base + addonCents());
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('.easify')) {
      setTimeout(apply, 30); // Easify werkt eerst zijn hidden inputs bij
    }
  });

  // Na variantwissel vervangt Dawn de prijs-HTML — add-on opnieuw optellen.
  // (PUB_SUB_EVENTS is een script-scope const, dus via typeof benaderen.)
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(apply, 120);
      });
    }
  } catch (e) {
    /* geen pub/sub beschikbaar — observer hieronder vangt het op */
  }

  // Vangnet: als de prijs-HTML door een DOM-swap terugvalt op de kale
  // variantprijs terwijl er een add-on geselecteerd is, opnieuw toepassen.
  var observerTimer = null;
  new MutationObserver(function () {
    if (observerTimer) return;
    observerTimer = setTimeout(function () {
      observerTimer = null;
      var el = document.querySelector('[data-zknl-base-cents]');
      if (!el) return;
      var base = parseInt(el.getAttribute('data-zknl-base-cents'), 10);
      var extra = addonCents();
      if (isNaN(base) || extra === 0) return;
      var expected = formatCents(base + extra);
      if (el.textContent.trim() !== expected) el.textContent = expected;
    }, 150);
  }).observe(document.body, { childList: true, subtree: true });
})();
